import React, { useEffect } from "react";
import SelfChatArtwork from "../components/SelfChatArtwork";
import OtherChatArtwork from "../components/OtherChatArtwork";
import { makeStyles } from "@material-ui/styles";
import { motion, AnimatePresence } from "framer-motion";
import { Dialog } from "@material-ui/core";

export const List = ({ items, classes }) =>
  items.map(({ isVisible, student, dialog, fading }, index) => (
    <AnimatePresence key={index}>
      {isVisible &&
        (student ? (
          <motion.div
            initial={{ height: 0, opacity: 0, y: 20, scale: 0.8 }}
            animate={{
              height: "100%",
              opacity: fading ? 0.5 : 1,
              y: 0,
              scale: fading ? 0.8 : 1,
            }}
            exit={{ height: "100%", opacity: 0, y: 0, scale: 0.5 }}
            transition={{ duration: 0.7 }}
          >
            <SelfChatArtwork {...dialog} className={classes.message} />
          </motion.div>
        ) : (
          <motion.div
            initial={{ height: 0, opacity: 0, y: 20, scale: 0.8 }}
            animate={{
              height: "100%",
              opacity: fading ? 0.5 : 1,
              y: 0,
              scale: fading ? 0.8 : 1,
            }}
            exit={{ height: "100%", opacity: 0, y: 0, scale: 0.5 }}
            transition={{ duration: 0.7 }}
          >
            <OtherChatArtwork {...dialog} className={classes.message} />
          </motion.div>
        ))}
    </AnimatePresence>
  ));
const useStyles = makeStyles({
  chatbar: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    bottom: "80%",
    left: "70%",
  },
  message: {
    margin: "4px 0px",
    direction: "rtl",
    left: 0,
    height: "auto",
  },
  "@media (max-width: 720px)": {
    message: {
      width: "40vw",
      height: "auto",
    },
  },
});

const Dialogs = [
  {
    dialogA: "Hi teacher! It's nice to",
    dialogB: "have an online class here.",
  },
  { dialogA: "Hi dear Ali!", dialogB: "Let's start the session." },
  { dialogA: "Ok. I have", dialogB: "done all my homework." },
  { dialogA: "Great! You're getting", dialogB: "better day by day ;)" },
];
/*
  "Hi teacher! It's nice to have an online class here.",
  "Hi dear Ali! Let's start the session.",
  "Ok. I have done all my homework. ",
  "Great! You're getting better day by day ;)",


*/

let currentDialog = 0;

export default function Chatbar() {
  const classes = useStyles();
  const [items, setItems] = React.useState([]);
  const call = (pool) => {
    setTimeout((_) => {
      if (pool.length > 2) {
        let firstVisible = pool.findIndex((item) => {
          if (typeof item !== "undefined") {
            return item.isVisible;
          }
          return false;
        });
        if (typeof firstVisible != "undefined") {
          pool[firstVisible].isVisible = false;
        }
        let secondVisible = pool.findIndex((item) => {
          if (typeof item !== "undefined") {
            return item.isVisible;
          }
          return false;
        });
        if (typeof firstVisible != "undefined") {
          pool[secondVisible].fading = true;
        }
      }
      if (pool.length === 2) {
        pool[0].fading = true;
      }
      if (currentDialog > Dialogs.length - 1) {
        currentDialog = 0;
      }
      let dialog = Dialogs[currentDialog];
      currentDialog += 1;
      if ((pool[pool.length - 1] || { student: false }).student) {
        pool = [...pool, { isVisible: true, dialog, student: false }];
      } else {
        pool = [...pool, { isVisible: true, dialog, student: true }];
      }
      pool.forEach((item, index) => {
        if (index < pool.length - 4) {
          delete pool[index];
        }
      });
      setItems(pool);
      setTimeout((_) => call(pool), 1000);
    }, 1000);
  };
  useEffect((_) => {
    call([]);
  }, []);
  return (
    <div className={classes.chatbar}>
      <List
        items={items}
        classes={classes}
        add={(_) => {
          setItems([...items, { student: false }]);
        }}
      />
    </div>
  );
}
